import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import Vuetify from "vuetify";
import VueI18n from "vue-i18n";
import Vuebar from "vuebar";
import moment from "moment";
import { messages } from "./modules/localization";
import { ColorPicker, ColorPanel } from "one-colorpicker";
import ru from "vuetify/src/locale/ru.ts";
moment.locale("ru");

// import "vue-country-code/dist/vue-country-code.css";
import "./stylus/style.styl";
import "./scss/style.scss";

Vue.config.productionTip = false;

Vue.use(Vuetify, {
  theme: {
    primary: "#005CFF",
    textPrimary: "#98B3CF",
    secondary: "#1A385B",
    accent: "#D8EDFF",
    error: "#FF5B37",
    info: "#7D98B7",
    success: "#00C29F",
    warning: "#FF9900"
  },
  lang: {
    locales: { ru },
    current: "ru"
  },
  iconfont: "fa",
  icons: {
    dropdown: "icon-arrow-bottom"
  }
});
Vue.use(VueI18n);
Vue.use(Vuebar);
Vue.use(ColorPicker);
Vue.use(ColorPanel);

Vue.component("v-style", {
  render: function(createElement) {
    return createElement("style", this.$slots.default);
  }
});

// фильтр даты для шаблонов
Vue.filter("date", function(value, format) {
  if (value) {
    return moment(new Date(value)).format(format);
  }
});

new Vue({
  router,
  store,
  i18n: new VueI18n({
    locale: "ru",
    messages
  }),
  render: h => h(App)
}).$mount("#app");
